import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('invoicesInfoPage.errors.name'),
  address: Yup.string().required('invoicesInfoPage.errors.address'),
  numberId: Yup.string().required('invoicesInfoPage.errors.numberId'),
});
